import { DisasterDatum, DisasterFilter, GeorefData, TSDatum } from '@/lib/types'
import * as geojson from 'geojson'
import { GeoJSON } from 'leaflet'

export type ViewType = 'trend' | 'time' | 'season' | 'map'

export type TrendView = 'clim' | 'enAnoms' | 'lnAnoms' | 'seasAnoms'

export type LanguageType = 'en' | 'pt'

export interface State {
	language: LanguageType
	loadingCount: number
	cloudData: GeoJSON<geojson.FeatureCollection> | null
	tsData: TSDatum[] | null
	georefData: GeorefData | null
	disasterData: DisasterDatum[] | null
	date2DisasterIndex: Map<number, number[]>
	disasterFilter: DisasterFilter
	tsClimatology: number[] | null
	selectedEvent: GeoJSON.FeatureCollection | null
	selectedEventIndex: number
	selectedFeature: GeoJSON | null
	selectedFeatureIndex: number
	selectedSeasonIndex: number
	color: string
	showRainfall: boolean
	trendView: TrendView
	selectedView: ViewType
	playing: boolean
	showOverview: boolean
	showOverviewOnStart: boolean
}

export const state: State = {
	language: 'en',
	loadingCount: 0,
	cloudData: null,
	tsData: null,
	georefData: null,
	disasterData: null,
	date2DisasterIndex: new Map(),
	disasterFilter: {
		cloudBandOnly: true,
		floods: true,
		flashFloods: true,
		drought: true,
		hail: true,
		storms: true,
		landslide: true,
		erosion: true,
		frost: true
	},
	tsClimatology: null,
	selectedEvent: null,
	selectedEventIndex: 0,
	selectedFeature: null,
	selectedFeatureIndex: 0,
	selectedSeasonIndex: 38,
	color: 'tomato',
	showRainfall: false,
	trendView: 'clim',
	selectedView: 'trend',
	playing: false,
	showOverview: true,
	showOverviewOnStart: true
}
